import React from "react";
import CreateNew from "../../components/createNew/CreateNew";
function Post() {
  return (
    <>
      <div className="post">
        <CreateNew />
      </div>
    </>
  );
}

export default Post;
